import { config } from '~/config';
import paths from '~/routes/paths';

/* All exports from this file should be functions for easier testing */

export const isNotProduction = () => window.location.href.indexOf('securetempus.com') === -1;

export const isSessionTimeoutModalOn = () => config.toggles?.sessionTimeoutModalOn === '1';

export const isProviderReportingToggleOn = () => config.toggles.providerReporting === '1';

// IAC toggle enables reporting for all users; otherwise use the care-pathways feature flag.
export const canViewProviderReporting = (isCarePathwaysEnabled: boolean) =>
  isProviderReportingToggleOn() || isCarePathwaysEnabled;

export const isGaelToggleOn = () => config.toggles.gaelEnabled === '1';

/** Hides the Trials page Find Trials / Materials tabs. Materials is the only destination. */
export const isTrialTabsHidden = () => config.toggles.hideTrialTabs === '1';

export const getTrialsLandingPath = () => (isTrialTabsHidden() ? paths.TRIAL_MATERIALS : paths.TRIAL_SEARCH);

// IAC toggle enables GAEL for all users; otherwise use the gael feature flag.
export const isGaelEnabled = (isGaelFeatureEnabled: boolean) => isGaelToggleOn() || isGaelFeatureEnabled;
